module.exports = __webpack_public_path__ + "images/emoji/ribbon.94f5405287236ad0dd2b.png";